export const COUNT_ADS_PER_PAGE = 20;
export const COUNT_REQUESTS_PER_PAGE = 5;
